// extracted by mini-css-extract-plugin
export default {"modal":"RsyV2","body":"PCo24","grid":"mGsaH","image":"Gu9Dp","selected":"UN8f9","buttons":"zwJLB","cancel":"JBygE","button":"OPaCV"};